import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';
import type { SelectorButtonProps } from '../types';

export const ArticleUniverseFilterQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
    selectedIds: string[];
    props?: SelectorButtonProps;
}>({
    isOpen: false,
    selectedIds: []
});

export default function useArticleUniverseFilterQuickView() {
    return useMediatorState(ArticleUniverseFilterQuickViewAtom);
}
